import React, {useState, useEffect} from 'react';
import LoginComponent from '../components/LoginComponent';
import mainStore from '../../../stores/mainStore';
import * as mainActions from "../../../actions/actions";
import queryString from "query-string";
import {useLocation} from "react-router-dom";


const Login = () => {
  const {search} = useLocation();
  const [form, setForm] = useState({
    email: {
      value: '',
      touched: false,
      valid: false
    },
    password: {
      value: '',
      touched: false,
      valid: false
    },
  });
  
  const [loginError, setLoginError] = useState(mainStore.state.loginError)
  
  const validateField = (fieldName, value) => {
    switch (fieldName) {
      case 'email':
        return mainStore.validateEmail(value);
      case 'password':
        return value.length > 7;
      default:
        return false;
    }
  };
  
  const onChangeInput = (e) => {
    const {value, name} = e.target;
    const isValid = validateField(name, value);
    
    setForm({
      ...form,
      [name]: {
        value,
        valid: isValid,
        touched: true,
      }
    })
  };
  
  useEffect(() => {
    mainStore.on('change', () => {
      setLoginError(mainStore.state.loginError);
    });
  }, [mainStore.loginError]);
  
  useEffect(() => {
    mainStore.on('change', () => {
      const {data: mainData , env_suffix} = mainStore.state.loginResponse;
      const {data, status } = mainData
      console.log(`data: ${JSON.stringify(data)}`)
      if(status === "ok" && data !== null){
        mainStore.setCookie("tm-access-token", data.access_token,1);
      
        const values = queryString.parse(search);
        let redirectUrl = values.redirectUrl;
        if (redirectUrl && redirectUrl.indexOf(window.location.hostname)===-1) {
          if (redirectUrl.indexOf("http://")===-1 && redirectUrl.indexOf("https://")===-1) {
            redirectUrl = 'http://'+redirectUrl;
          }
        } else {
          redirectUrl = `https://console${env_suffix || ''}.triplemars.com`
        }
        console.log(`redirect url: ${redirectUrl}`)
        window.location = redirectUrl;
      } else {
        console.log('Failed to generate tm-access-token')
        alert('Oops something went wrong')
      }
    });
  }, [mainStore.state.loginResponse])
  
  useEffect(() => {
    const _onInit = auth2 => {
      // console.log('init OK', auth2)
    }
    
    const _onError = err => {
      console.log('error', err)
    }
    
    if(window.gapi !== undefined){
      window.gapi.load('auth2', function() {
        window.gapi.auth2.init({
              client_id:
              '82074183733-ofluq1uudv6djh0gjg8ju5i92qf7je9f'
            })
            .then(_onInit, _onError)
      });
    }
  }, [window.gapi]);
  
  const triggerLogin = (provider, accessToken) => {
    const payload = {
      "auth_provider": provider,
      "provider_access_token": accessToken
    }
    mainActions.socialLogin(payload)
  }
  const fbSignIn = () => {
    window.FB.getLoginStatus(function(response) {
      if (response.status === 'connected') {
        const {accessToken} = response.authResponse;
        triggerLogin('facebook', accessToken);
        return;
      }
  
      window.FB.login(function(response) {
        if (response.status === 'connected') {
          const {accessToken} = response.authResponse;
          triggerLogin('facebook', accessToken);
          return;
        } else {
          console.log('User cancelled login or did not fully authorize.');
        }
      }, {scope: 'public_profile,email'});
    });
  };
  
  const googleSignIn = () => {
    const auth2 = window.gapi.auth2.getAuthInstance();
    
    auth2.signIn().then(googleUser => {
      // token
      const authReponse = googleUser.getAuthResponse(true)
      const access_token = authReponse.access_token
      triggerLogin('google', access_token)
    })
  };
  
  const onSubmit = () => {
    if (form.email.valid && form.password.valid) {
      mainActions.login({
        email: form.email.value,
        password: form.password.value,
      });
    }
  };
  
  return (
      <LoginComponent
          formData={form}
          loginError={loginError}
          onChange={onChangeInput}
          onSubmit={onSubmit}
          googleSignIn={googleSignIn}
          fbSignIn={fbSignIn}
      />
  );
};

export default Login;